import React, {
  useEffect,
  useMemo,
  useRef
}                                 from 'react';
import {
  useDispatch,
  useSelector
}                                 from "react-redux";
import ImagePaneComponent         from "../components/reusable/ImagePaneComponent";
import NoVideoComponent           from "../components/reusable/NoVideoComponent";
import PaneTimeComponent          from "../components/reusable/PaneTimeComponent";
import SpinnerComponent           from "../components/reusable/SpinnerComponent";
import UnSupportedFormatComponent from "../components/reusable/UnSupportedFormatComponent";
import ZoomComponent              from "../components/reusable/ZoomComponent";
import useGetBrowseFrame          from "../hooks/useGetBrowseFrame";
import { ApplicationState }       from "../store";
import { AlertState }             from "../store/alerts/types";
import { APIState }               from "../store/API/types";
import {
  errorBrowsePane,
  startBrowsePane,
  successBrowsePane
}                                 from "../store/browse/actions";
import { BrowseState }            from "../store/browse/types";
import { setTimelineDate }        from "../store/timeline/actions";
import {
  chooseService,
  errorPaneTime,
  getBrowseStreamFromCamera,
  getLocalBounds,
  successPaneTime
}                                 from "../utils";


const AlertPaneBrowseContainer = () => {
  const dispatch = useDispatch();
  const ref = useRef<HTMLDivElement>(null);
  const {cameras, privileges} = useSelector<ApplicationState, APIState>(state => state.API);
  const {browsePanes} = useSelector<ApplicationState, BrowseState>(state => state.browse);
  const {selectedEvent} = useSelector<ApplicationState, AlertState>(state => state.alerts);
  const canBrowse = privileges && privileges.canBrowse;

  const pane = 0;
  const time = selectedEvent ? new Date(chooseService(
    () => selectedEvent.when,
    () => parseInt(selectedEvent.when)
  )).valueOf() : null;

  const cameraId = useMemo(() => chooseService(
    () => selectedEvent ? selectedEvent.where_id : null,
    () => selectedEvent ? selectedEvent.cameras && selectedEvent.cameras.filter((c: any) => {
      let isPresent = false;
      cameras.forEach((c2: any) => {
        if (c2.name === c['a:Name']) {
          return isPresent = true;
        }
      });
      return isPresent;
    })[0]?.["a:EntityID"] : null
  ), [selectedEvent, cameras]);

  const currentCameraId = chooseService(
    () => null,
    () => browsePanes?.[pane]?.id
  );

  const src = useGetBrowseFrame(pane, time);

  const id = selectedEvent ? selectedEvent.id : null;

  const error = browsePanes[pane] && browsePanes[pane].error;
  const success = browsePanes[pane] && browsePanes[pane].success;
  const fetch = browsePanes[pane] && browsePanes[pane].fetch;
  const inited = browsePanes[pane] && browsePanes[pane].inited;

  useEffect(() => {
    if (cameraId) {
      const {width, height} = getLocalBounds(ref.current);
      const {error, stream} = chooseService(
        () => getBrowseStreamFromCamera(cameras, cameraId),
        () => ({error: false, stream: {stream_id: null}})
      );
      if (!error) {
        chooseService(
          () => dispatch(startBrowsePane({
            pane: pane,
            width: Math.floor(width),
            height: Math.floor(height),
            camId: cameraId,
            streamId: stream.stream_id
          })),
          () => dispatch(startBrowsePane({
            pane: pane,
            width: Math.floor(width),
            height: Math.floor(height),
            camId: cameraId,
            streamId: stream.stream_id
          }))
        )
      }

      if (time) dispatch(setTimelineDate(time))
    }
  }, [id]);


  const onImageLoad = () => {
    dispatch(successBrowsePane(pane));
    successPaneTime(pane);
  };

  const onImageError = () => {
    dispatch(errorBrowsePane(pane));
    errorPaneTime(pane);
  };

  return (
    <div className='pos-rel w-100 h-100 o-hidden'
         ref={ref}
         id='pane-0'
    >
      {
        (!canBrowse && id) && <UnSupportedFormatComponent data={'Unprivileged Feed'}/>
      }
      {
        error && <NoVideoComponent/>
      }
      {
        !success && <div className='w-100 h-100 flex al-it-c js-c'>
          {(fetch || inited) && <SpinnerComponent/>}
        </div>
      }
      {
        <ZoomComponent enable={true}
                       pane={0}
        >
          <div className='w-100 h-100 flex al-it-c js-c'>
            {
              (src && time) &&
              <>
                <ImagePaneComponent src={src ? src : ''}
                                    pane={pane}
                                    alt={'thumbnail-' + pane}
                                    className={'thumbnail-pane'}
                                    time={time}
                                    onload={onImageLoad}
                                    onerror={onImageError}
                />
                <PaneTimeComponent pane={pane}
                                   time={time}
                />
              </>
            }
          </div>
        </ZoomComponent>
      }
    </div>
  )
};

export default AlertPaneBrowseContainer;